module.exports = __webpack_public_path__ + "img/success.51b2dbae.png";